import styled from 'styled-components/macro';
import PropTypes from 'prop-types';
import {colors, textSizes} from '@styles/vars';
import {getClinicInitial} from '@utils/tenant';

const Circle = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${props => props.$size}px;
  height: ${props => props.$size}px;
  border-radius: ${props => (props.$size <= 32 ? '8px' : '14px')};
  flex-shrink: 0;
  background: ${colors.blue};
  color: #fff;
  font-size: ${props => (props.$size <= 28 ? textSizes['10'] : props.$size <= 32 ? textSizes['12'] : textSizes['18'])};
  font-weight: 700;
  line-height: 1;
  text-transform: uppercase;
`;

const ClinicAvatar = ({name, size = 30, className}) => (
    <Circle $size={size} className={className} aria-hidden="true">
        {getClinicInitial(name)}
    </Circle>
);

ClinicAvatar.propTypes = {
    name: PropTypes.string,
    size: PropTypes.number,
    className: PropTypes.string
};

export default ClinicAvatar;
